export const formatReferrerName = referrer => {
  if (!referrer?.company?.name) return referrer?.name;
  if (referrer?.name !== referrer?.company.name) {
    return `${referrer?.name} (${referrer?.company?.name})`;
  }
  return referrer?.name;
};